<template>
  <div>
    <v-row>
      <v-col>
        <v-card class="pa-5" height="400">
          <div>Connected Equipment: {{connectedAligners}}</div>
          <div>Total Equipment: {{totalAligners}}</div>
          <div>Connected Users: {{connectedUsers}}</div>

          <sparkline :indicatorStyles="false">
            <sparklineLine
              :data="connectedAlignersTrend"
              :limit="60"
              :styles="{ stroke: '#54a5ff' }"
            >
            </sparklineLine>
          </sparkline>

          <v-progress-circular
            :rotate="90"
            :size="50"
            :width="10"
            :value="alignersConnectedPercent"
            color="#54a5ff"
          >
            {{alignersConnectedPercent}}
          </v-progress-circular>

        </v-card>
      </v-col>
      <v-col>
        <v-card class="pa-5" height="400">
          <div>Open Support Tickets: {{openSupportTickets}}</div>
          <div>Closed Support Tickets: {{closedSupportTickets}}</div>
          <div>Total Tickets Issued: {{totalSupportTickets}}</div>

          <div style="width: 100%; text-align: center;">
            <column-chart :data="openTicketsData" style="width: 100%; height: 200px;"></column-chart>
          </div>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="pa-5" height="400">
          <div>
            <v-row style="padding:0px !important;">
              <v-col style="padding:0px !important;">
                <div style="height:28px;">logging:</div>
                <div style="height:28px;">gateway:</div>
                <div style="height:28px;">auth:</div>
                <div style="height:28px;">equipment:</div>
                <div style="height:28px;">aligner update:</div>
                <div style="height:28px;">Tru-Point update:</div>
                <div style="height:28px;">radar:</div>
                <div style="height:28px;">camera calibration:</div>
                <div style="height:28px;">EZ-ADAS:</div>
                <div style="height:28px;">Tru-Point integrations:</div>
                <div style="height:28px;">dashboard:</div>
                <div style="height:28px;">websockets:</div>
                <div style="height:28px;">Notifications:</div>
              </v-col>
              <v-col style="padding:0px !important;">
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.silvio ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('silvio')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.charon ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('charon')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.dalton ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('dalton')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.aligners ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('aligners')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.softwareUpdates ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('softwareUpdates')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.gtpsSoftwareUpdates ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('gtpsSoftwareUpdates')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.radar ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('radar')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.cameraCal ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('cameraCal')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.easy ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('easy')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.truPoint ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('truPoint')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.dashboard ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('dashboard')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.websockets ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('websockets')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
                <div style="display:flex;height:28px;">
                  <div style="min-width:100px;">{{$store.state.serviceStatus.pushNotifications ? 'up' : 'down'}}</div>
                  <v-btn text small @click="restart('pushNotifications')" v-if="$store.state.auth.token.user.role === 'admin'">restart</v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <!--
      <v-col>
        <v-card class="pa-5" height="300px">
          <div>Software Version Counts:</div>
          <div style="width: 100%; text-align: center;">
            <column-chart :data="installedVersionsData" style="width: 100%; height: 200px;"></column-chart>
          </div>
        </v-card>
      </v-col>
      <v-col>
        <v-card class="pa-5" height="300px">
          <div>Top 10 Aligners:</div>
          <div style="width: 100%; text-align: center;">
            <column-chart :data="top10Aligners" style="width: 100%; height: 200px;"></column-chart>
          </div>
        </v-card>
      </v-col>
      -->
    </v-row>
  </div>
</template>

<script>
import sparkline from 'vue-sparklines';
import moment from 'moment';

export default {
  components: {
    sparkline,
  },

  mounted() {
    // this.getData();
  },

  methods: {
    restart(serviceName) {
      console.log(`need to restart ${serviceName}`);

      const options = {
        method: 'POST',
        url: `/api/v1/reset_service/?serviceName=${serviceName}`,
      };

      this.axios(options)
        .then(() => {
          console.log(`server responded ok to the reset of ${serviceName}`);
        })
        .catch((err) => {
          console.log(`server error: ${err.message}`);
        });
    },
  },

  computed: {
    installedVersionsData() {
      const result = [];

      this.$store.state.alignerSoftwareVersions.forEach((cur) => {
        result.push([cur.version, cur.total]);
      });

      return result;
    },

    top10Aligners() {
      const result = [];

      this.$store.state.top10Aligners.forEach((cur) => {
        result.push([cur._id.serialNumber, cur.count]);
      });

      return result;
    },

    alignersConnectedPercent() {
      if (this.$store.state.connectionCounters.totalAligners > 0) {
        const p = Math.floor(this.$store.state.connectionCounters.connectedAligners / this.$store.state.connectionCounters.totalAligners * 100);
        return p;
      }

      return 0;
    },

    connectedAlignersTrend() {
      return this.$store.state.connectedAlignersTrend;
    },

    connectedAligners() {
      return this.$store.state.connectionCounters.connectedAligners;
    },

    totalAligners() {
      return this.$store.state.connectionCounters.totalAligners;
    },

    connectedUsers() {
      return this.$store.state.connectionCounters.connectedUsers;
    },

    openSupportTickets() {
      return this.$store.state.supportTicketStatistics.openTicketCount;
    },

    closedSupportTickets() {
      return this.$store.state.supportTicketStatistics.closedTicketCount;
    },

    totalSupportTickets() {
      return this.$store.state.supportTicketStatistics.totalTickets;
    },

    openTicketsData() {
      const result = [];

      this.$store.state.supportTicketStatistics.openTicketsByIssuerUsername.forEach((cur) => {
        result.push([cur.issuerUsername, cur.total]);
      });

      return result;
    },
  },
};
</script>

<style scoped>
</style>
